// src/eventBus.js

const listeners = {}

export const EventBus = {
    on(event, callback) {
        if (!listeners[event]) {
            listeners[event] = []
        }
        listeners[event].push(callback)
    },

    off(event, callback) {
        const arr = listeners[event]
        if (!arr) return
        const idx = arr.indexOf(callback)
        if (idx !== -1) arr.splice(idx, 1)
    },

    emit(event, payload) {
        const arr = listeners[event]
        if (!arr) return
        arr.slice().forEach(fn => fn(payload))
    }
}

